import { render } from "./B2bFiltersRecadvsReceived.vue?vue&type=template&id=e7a5c36e&scoped=true&lang=pug"
import script from "./B2bFiltersRecadvsReceived.vue?vue&type=script&lang=js"
export * from "./B2bFiltersRecadvsReceived.vue?vue&type=script&lang=js"

import "./B2bFiltersRecadvsReceived.vue?vue&type=style&index=0&id=e7a5c36e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7a5c36e"]])

export default __exports__